import styled, { css } from "styled-components"
import breakpoint from "styled-components-breakpoint"
import { lighten, readableColor, setLightness } from "polished"

const getColor = (variant, lightened) => {
  switch (variant) {
    case "primary":
      return ({ theme }) => (!!lightened ? lighten(0.025, theme.colors.primary) : theme.colors.primary)
    case "secondary":
      return ({ theme }) => (!!lightened ? lighten(0.025, theme.colors.secondary) : theme.colors.secondary)
    case "secondaryReadable":
      return (props) =>
        readableColor(
          props.theme.colors.secondary,
          props.theme.colors.buttons.darkColor,
          props.theme.colors.buttons.lightColor,
          false
        )
    default:
      return ({ theme }) => (!!lightened ? lighten(0.025, theme.colors.body) : theme.colors.body)
  }
}

const getHeightFromSize = (size) => {
  switch (size) {
    case "small":
      return "1px"
    default:
      return "2px"
  }
}

const getMargin = (margin) => {
  switch (margin) {
    case "small":
      return "0.5rem 0"
    default:
      return "1rem 0"
  }
}

export const StyledHr = styled.hr`
  display: block;
  height: ${({ size }) => getHeightFromSize(size)};
  color: ${({ variant, lightened }) => getColor(variant, lightened)};
  background-color: ${({ variant, lightened }) => getColor(variant, lightened)};
  border: none;
  margin: ${({ margin }) => getMargin(margin)};

  ${(props) =>
    !!props.mobileOnly &&
    !props.simpleForm &&
    breakpoint("tablet")`
    display: none;
  `}

  ${(props) =>
    props.light &&
    css`
      border-color: ${props.theme.colors.primary};
    `}

  ${(props) =>
    props.shadow &&
    css`
      border-color: ${setLightness(0.4, props.theme.colors.primaryContrastedDarker)};
    `}

  ${(props) =>
    props.body &&
    css`
      border-color: ${props.theme.colors.body};
    `}

  ${(props) =>
    props.halfMargin &&
    css`
      margin: 1.5rem 2rem;
    `}

  ${(props) =>
    props.halfMargin &&
    breakpoint("desktop")`
      margin: 0.5rem 1rem;
  `}

  ${(props) =>
    props.marginless &&
    breakpoint("tablet")`
      margin: 0;
    `}

  ${(props) =>
    props.navbar &&
    css`
      background-color: ${setLightness(0.4, props.theme.colors.primaryContrastedDarker)};
    `}

  ${(props) =>
    props.simpleForm &&
    css`
      display: block;
      background-color: #e6e6e6;
      margin: 1rem 0;
      height: 1px;
    `}
`
